import { InformationCircle32 } from '@packages/themes/icons';
import { Dialog, DialogContent, MuiIconButton } from '@packages/shared';
import { startTransition, useState } from 'react';
import { useIntl } from 'react-intl';
import { ServiceLayer } from '@packages/cms-components';
import type { RatingSeoResultFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { ratingInfoMessages } from './messages';

export type RatingInfoProps = {
  verifiedRatingsHintLayerId: RatingSeoResultFragmentFragment['verifiedRatingsHintLayerId'];
  isInline?: boolean;
};

/**
 * Info button and dialog with rating information
 */
export const RatingInfo = ({ verifiedRatingsHintLayerId, isInline }: RatingInfoProps) => {
  const [dialogOpened, setDialogOpened] = useState(false);
  const { formatMessage } = useIntl();

  if (!verifiedRatingsHintLayerId || verifiedRatingsHintLayerId === '') {
    return null;
  }

  return (
    <>
      {dialogOpened && (
        <Dialog
          open={dialogOpened}
          title={formatMessage({
            id: 'ratingsHint.title',
            defaultMessage: 'Info',
          })}
          handleClose={() => startTransition(() => setDialogOpened(false))}
          dialogContent={
            <DialogContent>
              <ServiceLayer serviceLayerId={verifiedRatingsHintLayerId} />
            </DialogContent>
          }
          displayTrackingProps={{
            category: 'dv-service-layer-raiting-info',
          }}
        />
      )}
      <MuiIconButton
        onClick={() => startTransition(() => setDialogOpened(true))}
        size="small"
        aria-label={formatMessage(ratingInfoMessages.ratingsHintLabel)}
        {...(isInline && {
          /* magic number from material UI styling -> the button has a hover effect that needs 5px space around the button */
          /* when used inline this space causes much more height then expected */
          /* so it has to be moved verticaly */
          sx: {
            my: '-5px',
          },
        })}
      >
        <InformationCircle32 color="info" fontSize="small" />
      </MuiIconButton>
    </>
  );
};
